import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import CloseEstimate from '../CloseEstimate';

import WindowIcon from '../../themes/svg/windowIcon';
import PriceTagIcon from '../../themes/svg/priceTagIcon';
import { formatPrice } from '../../helpers/formatNumbers';

const EstimateTab = (props) => {
  const estimateTabClass = classNames('estimateTab', {
    selected: props.isSelected,
  });

  const selectTheEstimate = () => {
    props.selectEstimate(props.id);
  };

  return (
    <div
      role="button"
      tabIndex="-1"
      className={estimateTabClass}
      key={`tab-${props.id}`}
      onClick={selectTheEstimate}
    >
      <div className="tab-header">
        <div className="name">
          <span className="truncateText" title={props.name}>{props.name}</span>
        </div>
        {props.allowClosing && <CloseEstimate id={props.id} />}
      </div>
      <div className="info">
        <div className="count">
          <WindowIcon />
          <span className="windowIcon">{props.itemCount}</span>
        </div>
        <div className="price">
          <PriceTagIcon />
          <span className="estimateTotal">{formatPrice(props.price)}</span>
        </div>
      </div>
    </div>
  );
};

EstimateTab.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  itemCount: PropTypes.number.isRequired,
  price: PropTypes.number.isRequired,
  isSelected: PropTypes.bool.isRequired,
  allowClosing: PropTypes.bool,
  selectEstimate: PropTypes.func.isRequired, // eslint-disable-line react/no-unused-prop-types
};

EstimateTab.defaultProps = {
  allowClosing: true,
};
export default EstimateTab;
